import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var DealerFireLogoIcon = function DealerFireLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 38 38' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: viewBox
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M18.75,2.84217094e-14 C29.1066217,2.84217094e-14 37.5,8.39508847 37.5,18.75 C37.5,29.1049115 29.1066217,37.5 18.75,37.5 C8.39508847,37.5 2.48689958e-14,29.1049115 2.48689958e-14,18.75 C2.48689958e-14,8.39508847 8.39508847,2.84217094e-14 18.75,2.84217094e-14 Z M17.6609814,6.06895294 C17.6541408,6.06382251 17.6250684,6.0877645 17.5942858,6.10828621 C17.6473003,6.20576432 17.703735,6.30153229 17.7516189,6.3990104 C18.5348641,7.96379059 18.6203712,9.54909248 17.9157926,11.1668871 C17.3377645,12.4956676 16.3544327,13.4909704 15.2975648,14.4452298 C14.3655372,15.28833 13.4403502,16.153662 12.6211921,17.102791 C11.6481211,18.2280646 10.9948468,19.543164 10.8665861,21.0617703 C10.7297747,22.7257388 11.2992521,24.1981713 12.1868159,25.5594445 C13.7567266,27.9707452 15.8909841,29.795467 18.3039949,31.3192038 C18.377531,31.3670877 18.4647483,31.3927399 18.557096,31.4337833 C18.5605162,31.3858993 18.5673568,31.3687979 18.5622264,31.3602472 C18.4921105,31.2730299 18.4202846,31.1892329 18.3501687,31.1037258 C17.0932142,29.5526268 16.4570412,27.7809194 16.6485772,25.7868935 C16.9717941,22.4452754 18.8632114,20.2169601 21.7892649,18.7564985 C22.0338152,18.6350784 22.1945686,18.6692813 22.2886264,18.9035708 C22.4852928,19.4012222 22.7418141,19.8937432 22.8307415,20.4136264 C23.160799,22.3358263 22.9487413,24.3401131 21.7328302,25.9237049 C22.3450611,25.9390961 26.9145613,21.610726 26.4767649,17.9390505 C26.3143013,15.4798659 25.2950565,13.3832315 23.8021023,11.4832634 C22.9076979,10.3425985 21.9312067,9.21048431 17.6609814,6.06895294 Z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.dealerFire,
        fillRule: 'evenodd'
      };
    }
  };
});